import React, { useState } from "react";
import { initializeApp } from "firebase/app";
import { getFirestore, collection, addDoc } from "firebase/firestore";
import "../styles/modal.css"; // Adjust the path if needed

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCBO5rIjsn4pYGTNYOAqSf3p_J0-AWFFvM",
  authDomain: "flourishtalents1.firebaseapp.com",
  projectId: "flourishtalents1",
  storageBucket: "flourishtalents1.appspot.com",
  messagingSenderId: "849498638792",
  appId: "1:849498638792:web:7bb743fa19ccc5a02358fd",
  measurementId: "G-YCH32G4072"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const firestore = getFirestore(app);

const ContactoRegister = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: ""
  });

  const placeholderMap = {
    "your success story": "Write your success story here",
    "your suggestion": "Write your suggestion here",
    "your complaint": "Write your complaint here",
    "your compliment": "Write your compliment here",
    "your request": "Write your request here",
    "your inquiry": "Write your inquiry here",
    "any other issue": "Write any other issue here"
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await addDoc(collection(firestore, "Contact_Form"), {
        ...formData,
        timestamp: new Date()
      });

      setFormData({ name: "", email: "", subject: "", message: "" });
      alert("Your message has been received!");
    } catch (error) {
      console.error("Error submitting form: ", error);
      alert("An error occurred. Please try again later.");
    }
  };

  return (
    <div>
      {/* Contact Form Section */}
      <section className="contact-form container">
        <h2 className="title has-text-centered">Get in Touch</h2>
        <form className="custom-form" onSubmit={handleSubmit}>
          <div className="field">
            <label className="label">Name</label>
            <div className="control">
              <input
                name="name"
                className="input custom-input"
                type="text"
                placeholder="Write your name here"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="field">
            <label className="label">Email</label>
            <div className="control">
              <input
                name="email"
                className="input custom-input"
                type="email"
                placeholder="Write your email address here"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="field">
            <label className="label">Subject</label>
            <div className="control">
              <select
                name="subject"
                className="input custom-input"
                value={formData.subject}
                onChange={handleChange}
                required
              >
                <option value="" disabled>
                  Select
                </option>
                {Object.keys(placeholderMap).map((key) => (
                  <option key={key} value={key}>
                    {key.replace(/your /, "").replace(/([A-Z])/g, " $1")}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="field">
            <label className="label">Message</label>
            <div className="control">
              <textarea
                name="message"
                className="textarea custom-input"
                placeholder={placeholderMap[formData.subject] || "Write your message here"}
                rows="4"
                value={formData.message}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="field">
            <div className="control">
              <button type="submit" className="custom-button">
                <span>Send Message</span>
              </button>
            </div>
          </div>
        </form>
      </section>

      {/* Sign Up Section */}
      <section className="thank-you lazyloaded">
        <div className="thank-you-text">Get started</div>
        <div className="signup-button-wrapper">
          <button type="button" className="button primary is-medium is-rounded custom-sign-up-now">
            <span>Sign up now</span>
          </button>
        </div>
      </section>
    </div>
  );
};

export default ContactoRegister;
